import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowRightSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.594 8 5.297 3.703l1.414-1.414L12.423 8 6.71 13.711l-1.414-1.414L9.594 8z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

export default IconArrowRightSizeS;
